import { send } from 'server';

export const getPlayerSingleBetLimit = () => send({
    ID: 35796,
    responses: [35798, 35797],
    description: 'Get Player Single Bet Limits'
});
